<template lang="pug">
v-container(ma-0 pa-0 fluid)
  v-layout.video-and-news(wrap='')
    v-flex.section-video-and-news-video(xs12='' offset-md1 md6)
      v-layout(align-center justify-center space-between fill-height)
        v-flex(xs12='' )
          iframe(:src='video_url', 
                frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', 
                allowfullscreen='')
    v-flex.section-video-and-news-news(xs10='' offset-xs1 offset-md0 md4)
      v-layout.intro-text(align-center justify-center column fill-height)
        v-flex(xs1 text-xs-center='')
          h1.title-all 18歲，投下你的第一票！
          br
        v-flex(xs2 text-xs-left='')
          span.content-all(v-html="introContent")
        v-flex.hidden-sm-and-down.imgwrap(sm1)
          v-img.speaker( :src="speaker")

</template>

<script>
export default {
  data: () => ({
    video_url: "https://www.youtube.com/embed/JUv9xC7Lnn0",
    speaker: require("../assets/speaker.png"),
    introContent: '有些人認為，剛從高級中等學校畢業的同學，雖然已經是滿18歲的成年人，但因為還沒有經歷過社會現實，投票決定國家大事，應該等長大一些再說；有些人則認為，高中生已經具備足夠獨立的思辨能力，也應該可以對自己想做的事負責。<br><br>在學校，依據《高級中等教育法》的規定：「高級中等學校應輔導學生成立由全校學生選舉產生之學生會及其他相關自治組織」，在18歲之前，多數的同學都已經投過第一次票，共同參與校園的大小決定。<br><br>18歲能不能投票，你怎麼看？其他國家的人又是怎麼想的呢？',
    news: []
  }),
  mounted() {}
};
</script>

<style lang="scss" scoped>
.video-and-news {
  position: relative;
  min-height: calc(100vh - 100px);
}

.section-video-and-news-video {
  align-items: center;
  justify-content: center;
  iframe {
    height: 60vh;
    width: 100%;
  }
}

.intro-text {
  margin-left: 50px;
  @media screen and (max-width: 480px) {
    margin-left: 0;
  }
}

.imgwrap {
  position: absolute;
  right: 3vw;
  bottom: 5vh;
  transform: rotate(30deg);
  width: calc(5vw + 10px);
  height: calc(5vw + 10px);
}
</style>
